import React from 'react';
import {IconButton, Switch} from 'evergreen-ui';

interface props {
  channelList: any[];
  onConnectionChange: (status: boolean) => void;
  onEditClick: (channel: any) => void;
  setConnectableChannel: (val: any) => void;
}

const FacebookChannel: React.FC<props> = (
  {
    channelList,
    onConnectionChange,
    onEditClick,
    setConnectableChannel,
  }) => {
  return (
    <div className='channel-settings__card-holder'>
      {channelList.length !== 0 && (
        <div className='channel-settings__card-holder-elem bg-white'>
          <div className='channel-settings__card-holder-elem-item'>Title</div>
          <div className='channel-settings__card-holder-elem-item'>Link</div>
          <div className='channel-settings__card-holder-elem-item'>
            Connected Page
          </div>
          <div className='channel-settings__card-holder-elem-item'>Edit</div>
          <div className='channel-settings__card-holder-elem-item'>
            Connection
          </div>
        </div>
      )}
      {channelList.map((channel: any, index: number) => (
        <div className='channel-settings__card-holder-elem' key={index}>
          <div className='channel-settings__card-holder-elem-item fs-12px'>
            {channel.title || 'Not Available'}
          </div>
          <div
            className='channel-settings__card-holder-elem-item fs-12px'
            title={channel.url}
          >
            {!!channel.url && <a
              className='link-settings'
              href={channel.url}
              target='_blank'
              rel='noopener noreferrer'
            >
              {channel.url}
            </a>}
            {!channel.url && "Link Not Available"}
          </div>
          <div className='channel-settings__card-holder-elem-item fs-12px'>
            {channel.name || 'Not Available'}
          </div>
          <div className='channel-settings__card-holder-elem-item fs-12px'>
            <IconButton
              className='icon-button__no-box-shadow'
              icon={'edit'}
              height={26}
              appearance='minimal'
              intent={'success'}
              onClick={() => onEditClick(channel)}
            />
          </div>
          <div className='channel-settings__card-holder-elem-item fs-12px'>
            <Switch
              className='active-switch-green'
              hasCheckIcon={false}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                onConnectionChange(event.target.checked);
                setConnectableChannel(channel);
              }}
              checked={channel.is_connected}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default FacebookChannel;
